import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ConditionalDescription } from '../../../../model/sign/conditional-description';

@Component({
  selector: 'conditional-description',
  templateUrl: './conditional-description.component.html',
  styleUrls: ['./conditional-description.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConditionalDescriptionComponent),
      multi: true
    }
  ]
})
export class ConditionalDescriptionComponent implements ControlValueAccessor {
  @Input()
  _value: ConditionalDescription; // this is the updated value that the class accesses
  onChange: any = () => {};
  onTouch: any = () => {};

  constructor() {}

  get value() {
    return this._value;
  }

  // this value is updated by programmatic changes if( val !== undefined && this.val !== val){
  set value(val: ConditionalDescription) {
    this._value = val;

    this.onChange(val);
    this.onTouch(val);
  }

  // this method sets the value programmatically
  writeValue(value: ConditionalDescription): void {
    if (value) {
      this._value = value;
    } else {
      this._value = new ConditionalDescription();
    }
  }

  // upon UI element value changes, this method gets triggered
  registerOnChange(fn: any) {
    this.onChange = fn;
  }
  // upon touching the element, this method gets triggered
  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  onBooleanValueChanged(): void {
    this.onChange(this._value);
    this.onTouch(this._value);
  }
}
